import React from 'react';

import Link from 'next/link';

import FacebookCircleIcon from '@repo/ui/components/Icon/FacebookCircleIcon';
import InstagramCircleIcon from '@repo/ui/components/Icon/InstagramCircleIcon';
import PinterestIcon from '@repo/ui/components/Icon/PinterestIcon';
import TwitterCircleIcon from '@repo/ui/components/Icon/TwitterCircleIcon';
import YoutubeCircleIcon from '@repo/ui/components/Icon/YoutubeCircleIcon';
import { P4 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import Logo from 'components/Logo/Logo';
import { FlexRow } from 'styles/layouts';

import { IconWrapper, Wrapper } from './styles';
import { defaultTheme } from './theme';

const MobileFooter = (props) => {
  const theme = { ...defaultTheme, ...props.theme };
  const iconTheme = {
    color: theme.iconColor,
    activeColor: theme.iconColor,
    activeDefaultColor: theme.iconColor,
  };

  return (
    <Wrapper data-testid="footer" theme={theme}>
      <FlexRow alignItems="center" gap="5px">
        <Logo
          small
          dataTestId="footer--kittl-logo"
          theme={{
            logoColor: themeStyle.brandMain,
            textColor: themeStyle.inkBase,
          }}
        />
        <P4 small color={theme.color}>
          © Kittl {new Date().getFullYear()}
        </P4>
      </FlexRow>
      <FlexRow alignItems="center" gap="10px">
        <Link
          legacyBehavior
          passHref
          href="https://www.facebook.com/kittldesign"
        >
          <IconWrapper rel="noreferrer" target="_blank">
            <FacebookCircleIcon height="15px" theme={iconTheme} />
          </IconWrapper>
        </Link>
        <Link
          legacyBehavior
          passHref
          href="https://www.youtube.com/Kittldesign"
        >
          <IconWrapper rel="noreferrer" target="_blank">
            <YoutubeCircleIcon height="15px" theme={iconTheme} />
          </IconWrapper>
        </Link>
        <Link
          legacyBehavior
          passHref
          href="https://www.instagram.com/kittldesign/"
        >
          <IconWrapper rel="noreferrer" target="_blank">
            <InstagramCircleIcon height="15px" theme={iconTheme} />
          </IconWrapper>
        </Link>
        <Link
          legacyBehavior
          passHref
          href="https://www.pinterest.com/kittldesign"
        >
          <IconWrapper rel="noreferrer" target="_blank">
            <PinterestIcon height="17px" theme={iconTheme} />
          </IconWrapper>
        </Link>
        <Link legacyBehavior passHref href="https://twitter.com/kittldesign">
          <IconWrapper rel="noreferrer" target="_blank">
            <TwitterCircleIcon height="17px" theme={iconTheme} />
          </IconWrapper>
        </Link>
      </FlexRow>
    </Wrapper>
  );
};

export default MobileFooter;
